import { render, staticRenderFns } from "./AlarmRecord.vue?vue&type=template&id=200fc2fe&scoped=true"
import script from "./AlarmRecord.vue?vue&type=script&lang=js"
export * from "./AlarmRecord.vue?vue&type=script&lang=js"
import style0 from "./AlarmRecord.vue?vue&type=style&index=0&id=200fc2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200fc2fe",
  null
  
)

export default component.exports